import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EnterpriseAdminService {
    private http = inject(HttpClient);


    private baseUrl = environment.apiUrl + '/api/v1/enterprise-admin';

    addAdminRole(userId: string): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/role/${userId}/add`,null);
    }

    removeAdminRole(userId: string): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/role/${userId}/remove`,null);
    }
}
